import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-width: 90vw;
	width: 1100px;
  max-height: 90vh;
  overflow-y: auto;
`;

export const FormContent = styled.form`
  display: flex;
  flex-direction: column;
	gap: 1.5rem;
`;

export const FormActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const OptionItem = styled.div`
  padding: 1rem;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
`;

export const OptionActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ErrorMessage = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  border: 1px solid #f5c6cb;
  margin-bottom: 1rem;
`;
